"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var OebbNumberAnimation = /** @class */ (function () {
    function OebbNumberAnimation(element, endValue, startValue, duration, numberFormat) {
        var _this = this;
        if (startValue === void 0) { startValue = 0; }
        if (duration === void 0) { duration = 2000; }
        if (numberFormat === void 0) { numberFormat = 'keep'; }
        this.startTime = null;
        this.animationFrame = null;
        this.decimalSeperator = null;
        this.thousandSeperator = null;
        this.animate = function (timestamp) {
            if (_this.startTime === null) {
                _this.startTime = timestamp;
            }
            var elapsed = timestamp - _this.startTime;
            var progress = Math.min(elapsed / _this.duration, 1);
            var currentValue = _this.startValue + (_this.endValue - _this.startValue) * progress;
            _this.onUpdate(currentValue);
            if (progress < 1)
                requestAnimationFrame(_this.animate);
        };
        this.detectSeparators(endValue);
        this.decimalPlaces = this.getDecimalPlaces(endValue);
        this.element = element;
        this.startValue = startValue;
        this.endValue = this.formatAsNumber(endValue);
        this.duration = duration;
        this.numberFormat = numberFormat;
        this.numberFormatter = new Intl.NumberFormat(this.numberFormat == 'keep' ? 'de' : this.numberFormat, {
            minimumFractionDigits: this.decimalPlaces,
            maximumFractionDigits: this.decimalPlaces
        });
        this.onUpdate = function (value) {
            _this.element.textContent = _this.formatValue(value);
        };
        this.reset();
    }
    OebbNumberAnimation.prototype.detectSeparators = function (numberString) {
        var possibleSeparators = [',', '.', ' '];
        var lastSeparator = null;
        for (var i = numberString.length - 1; i >= 0; i--) {
            if (possibleSeparators.indexOf(numberString[i]) > -1) {
                if (lastSeparator === null) {
                    this.decimalSeperator = numberString[i];
                    lastSeparator = numberString[i];
                }
                else {
                    this.thousandSeperator = numberString[i] !== this.decimalSeperator ? numberString[i] : null;
                    break;
                }
            }
        }
    };
    OebbNumberAnimation.prototype.getDecimalPlaces = function (value) {
        return (value.split(this.decimalSeperator || '.')[1] || '').length;
    };
    OebbNumberAnimation.prototype.formatAsNumber = function (value) {
        var _a;
        return Number(value.replace(new RegExp("\\" + this.thousandSeperator, 'g'), '').replace((_a = this.decimalSeperator, (_a !== null && _a !== void 0 ? _a : '.')), '.'));
    };
    OebbNumberAnimation.prototype.formatValue = function (value) {
        var formattedValue = this.numberFormatter.format(value);
        if (this.numberFormat === 'keep') {
            var placeHolderThousand = '_TMP_';
            if (this.thousandSeperator) {
                formattedValue = formattedValue.replace(/\./g, placeHolderThousand);
            }
            else {
                formattedValue = formattedValue.replace(/\./g, '');
            }
            if (this.decimalSeperator) {
                formattedValue = formattedValue.replace(',', this.decimalSeperator);
            }
            if (this.thousandSeperator) {
                formattedValue = formattedValue.replace(new RegExp(placeHolderThousand, 'g'), this.thousandSeperator);
            }
        }
        return formattedValue;
    };
    OebbNumberAnimation.prototype.start = function () {
        this.reset();
        this.animationFrame = requestAnimationFrame(this.animate);
    };
    OebbNumberAnimation.prototype.reset = function () {
        if (this.animationFrame !== null) {
            cancelAnimationFrame(this.animationFrame);
            this.animationFrame = null;
        }
        this.startTime = null;
        this.onUpdate(this.startValue);
    };
    return OebbNumberAnimation;
}());
exports.OebbNumberAnimation = OebbNumberAnimation;
